import { ArrowsClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowsClockwise";
import { DropdownMenuItem } from "@volca/ui/components/ui/dropdown-menu";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { PayBreakdownPeriod, PayBreakdownRerunAction } from "./types";

export interface PayBreakdownRerunMenuAction {
  period: PayBreakdownPeriod | undefined;
  action: PayBreakdownRerunAction;
}

export const isPayBreakdownRerunMenuActionVisible = (
  rerun: PayBreakdownRerunMenuAction | undefined,
) => !!rerun?.period && rerun.action.isVisible;

interface PayBreakdownRerunMenuItemProps {
  rerun: PayBreakdownRerunMenuAction;
  busy?: boolean;
}

export const PayBreakdownRerunMenuItem = ({
  rerun,
  busy = false,
}: PayBreakdownRerunMenuItemProps) => {
  if (!isPayBreakdownRerunMenuActionVisible(rerun)) return null;

  const { action } = rerun;

  const isDisabled = busy || !action.canRunPeriod || action.isRunning;
  const disabledReason = isDisabled ? action.disabledReason : undefined;

  return (
    <DropdownMenuItem
      disabled={isDisabled}
      aria-busy={action.isRunning}
      onClick={action.onRun}
    >
      {action.isRunning ? (
        <Spinner aria-hidden />
      ) : (
        <ArrowsClockwiseIcon className="h-4 w-4" />
      )}
      <Stack align="start" gap={0}>
        Rerun payroll
        {disabledReason && <Text variant="caption">{disabledReason}</Text>}
      </Stack>
    </DropdownMenuItem>
  );
};
